export const OktaClientId = '0oaop0jixngcdBAzt696'
export const ENV = 'devops' as string
export const OVERSIGHT_ENV_NAME = 'oversight-staging'
export const GCS_ENV_NAME = 'staging-devops'
export const SUBDOMAIN_SUFFIX = 'gcs-staging'
